<template>
  <b-modal ref="sawing-schedule-modal" id="sawing-schedule-modal" size="lg" body-class="sawing-schedule-modal-body" hide-footer static>
    <template v-if="material">
      <template slot="modal-header">
        <h4 class="modal-title">{{ material | materialName }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">

        <div class="col-md-13 sawing-schedule-header">
          <span class="panel-count">
            {{ panelcount() }}
            <template v-if="panelcount() === 1"> paneel</template>
            <template v-else> panelen</template>
          </span>
        </div>

        <div class="sawing-schedule">
          <div v-if="calculatingStatus" class="col-md-13">
            <font-awesome-icon class="font-awesome-icon"  icon="spinner" spin/>
          </div>

          <template v-if="sawingScheduleDetails" >
            <div v-for="(sawingSchedule, index) in sawingScheduleDetails" :key='index'>
              <div class="media">
                <div class="media-left">
                  <p><strong>Plan: {{ index+1 }}/{{ sawingScheduleDetails.length }}</strong></p>
                  <p>Aantal platen: {{ sawingSchedule.boardnumb }}</p>
                </div>
                <p class="image">
                  <img class="sawing-schedule-image" :src="sawingSchedule.image" alt="Zaagschema">
                </p>
              </div>

              <div class="seperator" v-if="index != sawingScheduleDetails.length - 1">
                <hr>
              </div>
            </div>
          </template>
        </div>
      </template>
    </template>
    <template v-else>
      <template slot="modal-header">
        <h4 class="modal-title">Zaagschema</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
      </template>
    </template>
  </b-modal>
</template>

<script>
  import { CALCULATE_ORDER } from '../../../store/types'

  export default {
    data() {
      return {
        material: null
      }
    },
    computed: {
      calculatingStatus() {
        return this.$store.getters.calculatingStatus
      },
      sawingScheduleDetails() {
        return this.$store.getters.sawingScheduleDetails(this.material.id)
      },
      cart() {
        return !this.$store.getters.cart ? null : this.$store.getters.cart
      }
    },
    methods: {
      panelcount() {
        let total = 0
        this.material.panels.forEach(function(panel) {
          total += panel.amount ? parseInt(panel.amount) : 0
        })
        return !total ? 0 : total
      },
      showModal(materialId) {
        // Get the material
        this.material = this.$store.getters.cartMaterial(materialId)

        // If we don't have any details, load them
        if (!this.sawingScheduleDetails || this.calculatingStatus === null) {
          this.$store.dispatch(CALCULATE_ORDER, this.cart)
        }

        this.$refs['sawing-schedule-modal'].show()
      },
      hideModal() {
        this.$refs['sawing-schedule-modal'].hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sawing-schedule-image {
    max-width: 100%;
  }

  .sawing-schedule-header {
    color: $light-grey;
  }

  .cursor-pointer {

    &:not(.disabled) {
      &:hover {
        color: $dark-grey;
      }
    }
  }

  .media {
    background: white;
    padding-top: 12px;

    .media-left  {
      padding-top: 10px;
      padding-left: 10px;

      p {
        margin-bottom: 5px;
        display: inline-block;
      }
    }
  }

  .seperator {
    background: white;
    padding: 1px 20px 1px 20px;
  }
</style>
